"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _statementExportApi = require("@/api/statementExportApi");
var _validate = require("@/utils/validate");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var POLL_INTERVAL = 3000;
var MAX_NETWORK_RETRIES = 3;
var ACTIVE_STATUSES = ['PENDING', 'WAITING', 'PROCESSING'];
var _default = exports.default = {
  name: 'StatementListExportTaskDialog',
  data: function data() {
    return {
      visible: false,
      isDuplicate: false,
      duplicateData: {},
      task: {},
      exportParams: {},
      pollTimer: null,
      pollGeneration: 0,
      detailLoading: false,
      actionLoading: false,
      retryLoading: false,
      redoLoading: false,
      networkRetryCount: 0,
      pollingStoppedByNetwork: false,
      autoDownloadedTaskIds: {},
      detailRequests: {},
      pendingDetailRefreshes: {}
    };
  },
  computed: {
    taskProgress: function taskProgress() {
      if (this.task.status === 'COMPLETED') return 100;
      var progress = Number(this.task.progress);
      if (Number.isNaN(progress)) return 0;
      return Math.min(100, Math.max(0, Math.round(progress)));
    },
    statusText: function statusText() {
      if (!this.task.detailLoaded && this.task.createMessage) {
        return this.task.createMessage;
      }
      var status = this.task.status;
      if (status === 'WAITING') {
        return this.task.queuePosition ? "\u6392\u961F\u4E2D\uFF0C\u5F53\u524D\u7B2C ".concat(this.task.queuePosition, " \u4F4D") : '排队中';
      }
      var textMap = {
        PENDING: '等待处理',
        PROCESSING: '正在导出',
        COMPLETED: '导出完成',
        FAILED: this.task.errorMessage || '导出失败',
        CANCELLED: '任务已中止'
      };
      return textMap[status] || '正在获取任务状态';
    },
    statusIcon: function statusIcon() {
      var iconMap = {
        PENDING: 'el-icon-time status-pending',
        WAITING: 'el-icon-time status-waiting',
        PROCESSING: 'el-icon-loading status-processing',
        COMPLETED: 'el-icon-success status-completed',
        FAILED: 'el-icon-error status-failed',
        CANCELLED: 'el-icon-warning status-cancelled'
      };
      return iconMap[this.task.status] || 'el-icon-loading status-processing';
    },
    downloadUrl: function downloadUrl() {
      return this.isDuplicate ? this.duplicateData.downloadUrl : this.task.downloadUrl;
    },
    downloadFileName: function downloadFileName() {
      return this.isDuplicate ? this.duplicateData.fileName : this.task.fileName;
    },
    canRetry: function canRetry() {
      return !this.isDuplicate && ['FAILED', 'CANCELLED'].includes(this.task.status);
    }
  },
  created: function created() {
    this.debouncedDuplicateReExport = (0, _validate.Debounce)(this.handleDuplicateReExport, 300);
  },
  beforeDestroy: function beforeDestroy() {
    this.stopPolling();
  },
  methods: {
    create: function () {
      var _create = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(params) {
        var createGeneration, data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.exportParams = _objectSpread({}, params);
              createGeneration = this.pollGeneration;
              _context.n = 1;
              return (0, _statementExportApi.createStatementListExportTask)(this.exportParams);
            case 1:
              data = _context.v;
              if (!(this._isBeingDestroyed || this._isDestroyed || createGeneration !== this.pollGeneration)) {
                _context.n = 2;
                break;
              }
              return _context.a(2, data);
            case 2:
              this.handleCreateResult(data || {});
              return _context.a(2, data);
          }
        }, _callee, this);
      }));
      function create(_x) {
        return _create.apply(this, arguments);
      }
      return create;
    }(),
    handleCreateResult: function handleCreateResult(data) {
      this.stopPolling();
      this.visible = true;
      this.isDuplicate = data.hasDuplicate === true;
      if (this.isDuplicate) {
        this.duplicateData = _objectSpread({}, data);
        this.task = {};
        return;
      }
      this.duplicateData = {};
      this.task = {
        taskId: data.taskId,
        status: data.inQueue ? 'WAITING' : 'PENDING',
        queuePosition: data.queuePosition,
        createMessage: data.inQueue ? '已加入队列' : '正在导出',
        detailLoaded: false
      };
      this.networkRetryCount = 0;
      this.pollingStoppedByNetwork = false;
      if (!data.taskId) {
        this.task = {
          status: 'FAILED',
          errorMessage: '创建成功，但未获取到任务编号'
        };
        return;
      }
      this.queryTaskDetail(true);
    },
    queryTaskDetail: function () {
      var _queryTaskDetail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(continuePolling) {
        var taskId, generation, data, pendingGeneration, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              taskId = this.task.taskId;
              if (taskId) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              if (!this.detailRequests[taskId]) {
                _context2.n = 2;
                break;
              }
              if (continuePolling) this.$set(this.pendingDetailRefreshes, taskId, this.pollGeneration);
              return _context2.a(2);
            case 2:
              generation = this.pollGeneration;
              this.$set(this.detailRequests, taskId, true);
              this.detailLoading = true;
              _context2.p = 3;
              _context2.n = 4;
              return (0, _statementExportApi.getStatementListExportTaskDetail)(taskId);
            case 4:
              data = _context2.v;
              if (this.isCurrentTask(taskId, generation)) {
                _context2.n = 5;
                break;
              }
              return _context2.a(2);
            case 5:
              this.networkRetryCount = 0;
              this.pollingStoppedByNetwork = false;
              this.task = _objectSpread(_objectSpread(_objectSpread({}, this.task), data || {}), {}, {
                taskId: taskId,
                detailLoaded: true
              });
              this.handleTaskStatus();
              _context2.n = 8;
              break;
            case 6:
              _context2.p = 6;
              _t = _context2.v;
              if (this.isCurrentTask(taskId, generation)) {
                _context2.n = 7;
                break;
              }
              return _context2.a(2);
            case 7:
              this.networkRetryCount += 1;
              if (this.networkRetryCount === 1) {
                this.$message.warning('查询导出进度时网络异常，正在自动重试');
              }
              if (!(this.networkRetryCount > MAX_NETWORK_RETRIES)) {
                _context2.n = 8;
                break;
              }
              this.pollingStoppedByNetwork = true;
              return _context2.a(2);
            case 8:
              _context2.p = 8;
              this.$delete(this.detailRequests, taskId);
              pendingGeneration = this.pendingDetailRefreshes[taskId];
              if (pendingGeneration !== undefined && pendingGeneration === this.pollGeneration && this.task.taskId === taskId) {
                this.$delete(this.pendingDetailRefreshes, taskId);
                this.detailLoading = false;
                this.queryTaskDetail(true);
              } else if (this.isCurrentTask(taskId, generation)) {
                this.detailLoading = false;
                if (continuePolling && ACTIVE_STATUSES.includes(this.task.status) && !this.pollingStoppedByNetwork) {
                  this.scheduleNextPoll(taskId, generation);
                }
              }
              if (this.task.taskId === taskId && !this.detailRequests[taskId]) {
                this.detailLoading = false;
              }
              return _context2.f(8);
            case 9:
              return _context2.a(2);
          }
        }, _callee2, this, [[3, 6, 8, 9]]);
      }));
      function queryTaskDetail(_x2) {
        return _queryTaskDetail.apply(this, arguments);
      }
      return queryTaskDetail;
    }(),
    isCurrentTask: function isCurrentTask(taskId, generation) {
      return this.task.taskId === taskId && this.pollGeneration === generation;
    },
    scheduleNextPoll: function scheduleNextPoll(taskId, generation) {
      var _this = this;
      this.clearPollTimer();
      this.pollTimer = setTimeout(function () {
        if (_this.isCurrentTask(taskId, generation)) {
          _this.queryTaskDetail(true);
        }
      }, POLL_INTERVAL);
    },
    handleTaskStatus: function handleTaskStatus() {
      if (!ACTIVE_STATUSES.includes(this.task.status)) {
        this.clearPollTimer();
      }
      if (this.task.status === 'COMPLETED') {
        this.autoDownloadOnce();
      }
    },
    autoDownloadOnce: function autoDownloadOnce() {
      var taskId = this.task.taskId;
      if (!taskId || !this.task.downloadUrl || this.autoDownloadedTaskIds[taskId]) return;
      this.$set(this.autoDownloadedTaskIds, taskId, true);
      this.downloadFile();
    },
    downloadFile: function downloadFile() {
      if (!this.downloadUrl) {
        this.$message.error('文件下载地址不存在');
        return;
      }
      this.$download.url(this.downloadUrl, this.downloadFileName);
    },
    refreshNow: function refreshNow() {
      this.networkRetryCount = 0;
      this.pollingStoppedByNetwork = false;
      this.queryTaskDetail(true);
    },
    handleCancel: function handleCancel() {
      this.confirmTaskAction('确定取消该排队任务吗？', _statementExportApi.cancelStatementListExportTask, '排队任务已取消');
    },
    handleStop: function handleStop() {
      this.confirmTaskAction('确定中止当前导出任务吗？', _statementExportApi.stopStatementListExportTask, '已发出中止指令');
    },
    confirmTaskAction: function confirmTaskAction(message, action, successMessage) {
      var _this2 = this;
      this.$confirm(message, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _this2.actionLoading = true;
              _context3.p = 1;
              _context3.n = 2;
              return action(_this2.task.taskId);
            case 2:
              _this2.$message.success(successMessage);
              _context3.n = 3;
              return _this2.queryTaskDetail(true);
            case 3:
              _context3.p = 3;
              _this2.actionLoading = false;
              return _context3.f(3);
            case 4:
              return _context3.a(2);
          }
        }, _callee3, null, [[1,, 3, 4]]);
      }))).catch(function () {});
    },
    handleRetry: function () {
      var _handleRetry = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _t2;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              if (!this.retryLoading) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              this.retryLoading = true;
              _context4.p = 2;
              _context4.n = 3;
              return this.create(this.exportParams);
            case 3:
              _context4.n = 5;
              break;
            case 4:
              _context4.p = 4;
              _t2 = _context4.v;
            case 5:
              _context4.p = 5;
              this.retryLoading = false;
              return _context4.f(5);
            case 6:
              return _context4.a(2);
          }
        }, _callee4, this, [[2, 4, 5, 6]]);
      }));
      function handleRetry() {
        return _handleRetry.apply(this, arguments);
      }
      return handleRetry;
    }(),
    handleDuplicateReExport: function handleDuplicateReExport() {
      var _this3 = this;
      if (this.redoLoading) return;
      var taskId = this.duplicateData.taskId;
      if (!taskId) {
        this.$message.error('任务编号不存在，无法重新导出');
        return;
      }
      this.$confirm('重新导出会删除当前重复任务记录，并按原筛选条件重新生成最新文件，是否继续？', '重新导出', {
        confirmButtonText: '确定重新导出',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _t3;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _this3.redoLoading = true;
              _context5.p = 1;
              _context5.n = 2;
              return (0, _statementExportApi.deleteStatementExportTask)(taskId);
            case 2:
              _this3.$message.success('旧任务已删除，正在按最新数据重新导出');
              _context5.n = 3;
              return _this3.create(_this3.exportParams);
            case 3:
              _context5.n = 5;
              break;
            case 4:
              _context5.p = 4;
              _t3 = _context5.v;
            case 5:
              _context5.p = 5;
              _this3.redoLoading = false;
              return _context5.f(5);
            case 6:
              return _context5.a(2);
          }
        }, _callee5, null, [[1, 4, 5, 6]]);
      }))).catch(function () {});
    },
    openRecords: function openRecords() {
      this.$emit('open-records');
    },
    clearPollTimer: function clearPollTimer() {
      if (this.pollTimer) {
        clearTimeout(this.pollTimer);
        this.pollTimer = null;
      }
    },
    stopPolling: function stopPolling() {
      this.clearPollTimer();
      this.pollGeneration += 1;
      this.detailLoading = false;
      this.pendingDetailRefreshes = {};
    }
  }
};